import React from "react";
import Select from "react-select";
import { Controller } from "react-hook-form";
import ValidationMsgComponent from "../ValidationMsgComponent";
import { Col, Row } from "reactstrap";

interface ControlledSelectProps {
    label?: string;
    inputName: string;
    placeholder?: string;
    invalid?: boolean;
    control: any;
    rules?: object;
    errors?: object;
    isRequired?: boolean;
    hasSideLabel?: boolean;
    sideLabel?: string;
    isDisabled?: boolean;
    defaultValue?: string;
    className?: string;
    optionsList: any;
    isLoading?: boolean;
    isSearchable?: boolean;
    defaultSelectedValue?: any;
    isMulti?: boolean;
    isClear?: boolean;
    value?: any;
    maxMenuHeight?: number;
    menuPlacement?: 'auto' | 'bottom' | 'top';
    menuPosition?: 'absolute' | 'fixed';
}

const ControlledSelect: React.FC<ControlledSelectProps> = ({
    label,
    inputName,
    optionsList,
    invalid,
    control,
    isLoading,
    isSearchable,
    rules,
    errors,
    defaultSelectedValue,
    isRequired,
    isMulti,
    isDisabled,
    placeholder,
    isClear,
    maxMenuHeight,
    menuPlacement,
    menuPosition,
}) => {
    return (
        <div className="mb-1">
            <Row>
                {label && (
                    <Col lg="4">
                        {label && (
                            <label htmlFor={inputName}>
                                {label} {isRequired && "*"}
                            </label>
                        )}
                    </Col>
                )}
                <Col lg={label !== "" ? 8 : 12}>
                    <Controller
                        name={inputName}
                        control={control}
                        rules={rules}
                        render={({ field }) => (
                            <Select
                                id={inputName}
                                classNamePrefix="select"
                                options={optionsList}
                                isClearable={isClear}
                                isLoading={isLoading}
                                isSearchable={isSearchable}
                                isMulti={isMulti}
                                isDisabled={isDisabled}
                                defaultValue={defaultSelectedValue}
                                placeholder={placeholder}
                                maxMenuHeight={maxMenuHeight}
                                menuPlacement={menuPlacement}
                                menuPosition={menuPosition}
                                {...field}
                                required={isRequired}
                            />
                        )}
                    />
                    {invalid && (
                        <ValidationMsgComponent
                            inputName={inputName}
                            invalid={invalid}
                            errors={errors}
                            rules={rules}
                        />
                    )}
                </Col>
            </Row>
        </div>
    );
};

export default ControlledSelect;
